import { render, staticRenderFns } from "./ViewJobWithCandidates.vue?vue&type=template&id=ab46a6b8&scoped=true"
import script from "./ViewJobWithCandidates.vue?vue&type=script&lang=ts"
export * from "./ViewJobWithCandidates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab46a6b8",
  null
  
)

export default component.exports